import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react";
import DinamicTable from '../../../shared/table';
import { useDispatch, useSelector } from 'react-redux';
import { formatNumber, formatUTCDate } from "../../../utils/functions";
import { getBills, getTotalElements } from '../../../../Redux/reducer/bills';
import { getBillsList, clearBillsList } from '../../../../Redux/actions/billActions';

const CalendarTable = (props) => {

  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(0);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);

  const headers = [
    { selector: "numFactura", name: t('dashboard.expiration.table.bills') },
    { selector: "name", name: t('dashboard.expiration.table.company') },
    { selector: "vencimiento", name: t('dashboard.expiration.table.expiration') },
    { selector: "monto", name: t('dashboard.expiration.table.amount') },
  ];

  const status = props.mode == 'Repago' ? 'PROCESSED' : props.mode;
  const expirationDate = props.mode == 'Repago' ? 'expirationLoanDate' : 'expirationDate';

  const filters = [
    { property: expirationDate, operator: 'eq', value: props.date },
    { property: 'status', operator: 'eq', value: status },
  ]
  const dispatch = useDispatch();
  const bills = useSelector(state => getBills(state));
  const totalElements = useSelector(state => getTotalElements(state));

  useEffect(() => {
    async function fetchBillList() {
      return await dispatch(getBillsList(currentPage, currentSizePerPage, filters));
    }

    fetchBillList();

    return () => {
      dispatch(clearBillsList());
    }
  }, []);

  const getData = () => {
    var data = [];

    if (bills.length > 0) {
      bills.map(item => {
        var symbol = item.currencyDetail !== undefined ? item.currencyDetail.currencyCode : "CRC";
        data.push({
          numFactura: item.numFactura,
          name: item.name,
          monto: formatNumber(item.monto, symbol),
          vencimiento: formatUTCDate(item.fechaVencimiento),
        })
      });
    }

    return data;
  }

  const handleTableChange = ({ page, sizePerPage }) => {
    return dispatch(getBillsList(page, sizePerPage, filters)).then(() => {
      setCurrentPage(page);
      setCurrentSizePerPage(sizePerPage);
    });
  };

  return (
    <DinamicTable
      headers={headers}
      data={getData()}
      page={currentPage}
      totalSize={totalElements}
      sizePerPage={currentSizePerPage}
      onTableChange={handleTableChange}
    />
  );
}

export default CalendarTable;